import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import NavBar from './common/NavBar';
import { setAccount } from '../../../../actions/account/account';
import { Loader } from '../../../common/elements';
import BackButton from "../../../dashboardNew/components/tools/BackButton";

class AccountSettingsMainPage extends Component {
	componentWillMount() {
		if ((!localStorage.token || !localStorage.permissions || parseInt(localStorage.unauthorized, 10) === 1)) {
			browserHistory.push('/login');
		}
	};

	componentDidMount() {
		const { setAccount } = this.props;
		const personId = localStorage.getItem('person_id');
		setAccount(personId);
	};

	render() {
		const { account, children } = this.props;

		if (account) {
			return (
				<article className="Site-content container settings-body">
					<main>
						<section className="row">
							<div className="col-xs-12 col-sm-3">
								<BackButton
									title="Go to Profile"
									path="/profile"
								/>
							</div>
							<div className="col-xs-12 col-sm-9 remove-heading">
								<h1 className="h1">Settings</h1>
							</div>
						</section>
						<section className="row">
							<nav className="col-xs-12 col-md-3">
								<NavBar />
							</nav>
							<div className="col-xs-12 col-md-9">
								{children}
							</div>
						</section>
					</main>
				</article>
			);
		} else {
			return (
				<article className="container settings-body">
					<main>
						<section className="row">
							<div className="col-xs-12 text-center">
								<h1 className="h1">Settings</h1>
								<hr />
								<Loader />
							</div>
						</section>
					</main>
				</article>
			)
		}
	};
}

AccountSettingsMainPage.propTypes = {
	account: PropTypes.object,
	setAccount: PropTypes.func
}

const mapStateToProps = (state) => {
	return {
		account: state.account.account,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setAccount: (person_id) => dispatch(setAccount(person_id)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountSettingsMainPage);


// WEBPACK FOOTER //
// src/client/components/site/features/account/AccountSettingsMainPage.js